import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);


export default class Main{

    constructor(){
        this.nowBattleClass = '';
        this._init();
    }


    _init(){
        this.playbackNavItems = document.querySelectorAll('.playback__navs__item');
        window.addEventListener('hashchange', this._onHashCHange.bind(this));
        this._onHashCHange();
    }


    _onHashCHange(){
        const hash = window.location.hash;

        if(hash==='#whats' || hash==='#howto'){

            if(this.playbackNavItems.length > 0){
                this.nowBattleClass = '.playback__battle.-battle1';
                document.querySelector(this.nowBattleClass).classList.add('-active');
            }
            
            this._smoothScroll(hash, -50);
        }
        else{

            if(this.playbackNavItems.length > 0){
                this._battleChange(hash);
            }
        }
    }


    _battleChange(_hash){

        // 現在のハッシュタグを取得
        const hash = _hash || '#battle1';
        const key = hash.replace('#', '');
        const battleSelector = `.playback__battle.-${key}`;

        // 現在のバトルクラスを削除
        if(this.nowBattleClass){
            const prevBattle = document.querySelector(this.nowBattleClass);
            if (prevBattle) prevBattle.classList.remove('-active');
        }

        // 該当のバトル要素を取得してアクティブクラスを付与
        const currentBattle = document.querySelector(battleSelector);
        if(currentBattle){
            currentBattle.classList.add('-active');
            this.nowBattleClass = battleSelector;
        }

        // ナビゲーションの `-current` クラスを更新
        this.playbackNavItems.forEach((item) => {
            const anchor = item.querySelector('a');
            if (anchor && anchor.getAttribute('href') === hash) item.classList.add('-current');
            else item.classList.remove('-current');
        });

        // スムーススクロール処理
        if(location.hash != ""){
            this._smoothScroll('#playback');
        }
    }

    _smoothScroll(hash, adjust=0){
        const targetElem = document.querySelector(hash);
        if(!targetElem) return;

        gsap.to(window, {duration: 0.5, scrollTo: targetElem.offsetTop+adjust, ease: 'power2.out'});
    }
}
